// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--JQZOA","icon":"a10a3f92e9--icon--vkn6F","remoteness":"a10a3f92e9--remoteness--OS2g_"};